// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IzUHDppKFDLq8Npwtxpp[data-has-many="true"] {
  width: var(--campaign-card-has-many-width);
  height: var(--campaign-card-has-many-height);
  padding: var(--campaign-card-has-many-padding);
  border: none;
  overflow: hidden;
  contain: layout style;
}
.KPY3M1wa2HeD8AMwCwEw[data-has-many="true"] {
  background-repeat: no-repeat;
}
.IzUHDppKFDLq8Npwtxpp[data-has-many="true"][data-view="single"][data-collapsed='true'] {
  width: var(--campaign-card-has-many-single-collapsed-width);
  height: var(--campaign-card-has-many-single-collapsed-height);
  padding: var(--campaign-card-has-many-single-collapsed-padding);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .IzUHDppKFDLq8Npwtxpp[data-has-many="true"] {
    width: var(--campaign-card-has-many-width-mobile);
    height: var(--campaign-card-has-many-height-mobile);
  }
  .IzUHDppKFDLq8Npwtxpp[data-has-many="true"][data-view="single"][data-collapsed='true'] {
    width: var(--campaign-card-has-many-single-collapsed-width-mobile);
    height: var(--campaign-card-has-many-single-collapsed-height-mobile);
  }
  .IzUHDppKFDLq8Npwtxpp[data-has-many="true"][data-view="single"][data-variant="card"] {
    padding: var(--campaign-card-has-many-single-card-padding-mobile);
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .IzUHDppKFDLq8Npwtxpp[data-has-many="true"][data-view="multi"][data-variant="card"] {
    width: var(--campaign-card-has-many-multi-card-width-tablet-portrait);
    height: var(--campaign-card-has-many-multi-card-height-tablet-portrait);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .IzUHDppKFDLq8Npwtxpp[data-has-many="true"][data-view="multi"][data-variant="card"] {
    width: var(--campaign-card-has-many-multi-card-width-tablet-portrait);
    height: var(--campaign-card-has-many-multi-card-height-tablet-portrait);
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/defaults/CampaignCard/css/hasManyStyles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2DAA2D;EAC3D,6DAA6D;EAC7D,+DAA+D;AACjE;AACA;EACE;IACE,iDAAiD;IACjD,mDAAmD;EACrD;EACA;IACE,kEAAkE;IAClE,oEAAoE;EACtE;EACA;IACE,iEAAiE;EACnE;AACF;AACA;AAAA;EACE;IACE,qEAAqE;IACrE,uEAAuE;EACzE;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;IACE,qEAAqE;IACrE,uEAAuE;EACzE;AACF;AAAA;AAAA;AAAA","sourcesContent":[".campaignCard[data-has-many=\"true\"] {\n  width: var(--campaign-card-has-many-width);\n  height: var(--campaign-card-has-many-height);\n  padding: var(--campaign-card-has-many-padding);\n  border: none;\n  overflow: hidden;\n  contain: layout style;\n}\n.backgroundImage[data-has-many=\"true\"] {\n  background-repeat: no-repeat;\n}\n.campaignCard[data-has-many=\"true\"][data-view=\"single\"][data-collapsed='true'] {\n  width: var(--campaign-card-has-many-single-collapsed-width);\n  height: var(--campaign-card-has-many-single-collapsed-height);\n  padding: var(--campaign-card-has-many-single-collapsed-padding);\n}\n@media (--campaign-mobile) {\n  .campaignCard[data-has-many=\"true\"] {\n    width: var(--campaign-card-has-many-width-mobile);\n    height: var(--campaign-card-has-many-height-mobile);\n  }\n  .campaignCard[data-has-many=\"true\"][data-view=\"single\"][data-collapsed='true'] {\n    width: var(--campaign-card-has-many-single-collapsed-width-mobile);\n    height: var(--campaign-card-has-many-single-collapsed-height-mobile);\n  }\n  .campaignCard[data-has-many=\"true\"][data-view=\"single\"][data-variant=\"card\"] {\n    padding: var(--campaign-card-has-many-single-card-padding-mobile);\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) and (--campaign-tablet-portrait-rule) {\n  .campaignCard[data-has-many=\"true\"][data-view=\"multi\"][data-variant=\"card\"] {\n    width: var(--campaign-card-has-many-multi-card-width-tablet-portrait);\n    height: var(--campaign-card-has-many-multi-card-height-tablet-portrait);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignCard": `IzUHDppKFDLq8Npwtxpp`,
	"backgroundImage": `KPY3M1wa2HeD8AMwCwEw`
};
export default ___CSS_LOADER_EXPORT___;
